import { GooglePlacesAutocompleteField } from './GooglePlacesCustomTextField';

export default GooglePlacesAutocompleteField;
